import { isAudioQuickConnectName } from "@expert/shared-types";

import type { ConferenceParticipant } from "@/sdk/agent/voice/conferenceTypes";

/**
 * Whether a pre-recorded audio-disclosure Quick Connect is currently in the conference (pending or
 * active — i.e. not yet disconnected). Used as a compliance guard to disable the customer's Hold
 * button while a disclosure is playing, so a required disclosure can't be played to a held customer.
 *
 * Derived from the live `conferenceParticipants` (the same signal that drives `isConference`) rather
 * than a separate playback event, matching the ARN-era "detect by live participant" approach.
 */
export function hasActiveDisclosureParticipant(participants: ConferenceParticipant[]): boolean {
    return participants.some(
        (participant) =>
            participant.type !== "inactive" &&
            !!participant.quickConnectName &&
            isAudioQuickConnectName(participant.quickConnectName),
    );
}
